import { render, staticRenderFns } from "./ManageValueBasedPricing.vue?vue&type=template&id=327f7b3d&"
import script from "./ManageValueBasedPricing.vue?vue&type=script&lang=js&"
export * from "./ManageValueBasedPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports